<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-textarea
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-textarea>

    <label class="label form_field--label">Choose the statuses you want to be in this pipeline.</label>

    <status-checkbox-group
      v-model="form.status_ids"
      heading="Contact Not Made Statuses"
      :statuses="statusesForContacting"
    ></status-checkbox-group>

    <status-checkbox-group
      v-model="form.status_ids"
      heading="Active Statuses"
      :statuses="statusesForActive"
    ></status-checkbox-group>

    <status-checkbox-group
      v-model="form.status_ids"
      heading="Follow Up Statuses"
      :statuses="statusesForFollowUp"
    ></status-checkbox-group>

    <status-checkbox-group
      v-model="form.status_ids"
      heading="Completed Statuses"
      :statuses="statusesForCompleted"
    ></status-checkbox-group>

    <status-checkbox-group
      v-model="form.status_ids"
      heading="Dead Statuses"
      :statuses="statusesForDead"
    ></status-checkbox-group>

    <status-checkbox-group
      v-model="form.status_ids"
      heading="Non Lead Statuses"
      :statuses="statusesForNonLead"
    ></status-checkbox-group>

    <form-validation-errors
      :validation-errors="validationErrors.status_ids"
    ></form-validation-errors>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import FormValidationErrors from "../components/form/FormValidationErrors";

export default {
  name: "PipelineViewForm",
  components: {FormValidationErrors},
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        label: "",
        description: "",
        status_ids: [],
      },
    };
  },
  computed: {
    statusesForContacting() {
      return this.$store.getters['pipeline/contactingStatuses'];
    },
    statusesForActive() {
      return this.$store.getters['pipeline/activeStatuses'];
    },
    statusesForFollowUp() {
      return this.$store.getters['pipeline/followUpStatuses'];
    },
    statusesForCompleted() {
      return this.$store.getters['pipeline/completedStatuses'];
    },
    statusesForDead() {
      return this.$store.getters['pipeline/deadStatuses'];
    },
    statusesForNonLead() {
      return this.$store.getters['pipeline/nonLeadStatuses'];
    },
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.defaultForm);
  },
  methods: {
    update() {
      return this.$api.pipelineViews.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Pipeline view was updated",
            type: "is-success"
          });

          return res;
        });
    },
    create() {
      return this.$api.pipelineViews.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Pipeline view was created",
            type: "is-success"
          });

          return res;
        });
    },
    delete() {
      return this.$api.pipelineViews.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Pipeline view was archived",
            type: "is-success"
          });

          return res;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
